/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return;

        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.slider = document.getElementById(this.target);

        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            event.preventDefault();
          });
        });

        window.addEventListener('resize', () => {
          if (!this.slider) return;
          let flkty = Flickity.data(this.slider);
          if (flkty) {
            flkty.resize();
          }
        });

        // Set initial collection on page load
        const activeButton = buttons[0];
        if (activeButton?.dataset.collection) {
          this.toggleCollection(activeButton.dataset.collection);
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const container = document.getElementById(this.target);
      if (!container) return;

      const isCarousel = container.classList.contains('carousel');

      const products = container.querySelectorAll(
        `.columns:not([data-collection="${handle}"])`
      );

      const activeProducts = container.querySelectorAll(
        `[data-collection="${handle}"]`
      );

      if (!isCarousel) {
        container.querySelectorAll('.columns').forEach(item => {
  item.classList.add('hidden-collection');
});

activeProducts.forEach(item => {
  item.classList.remove('hidden-collection');
});

        return;
      }

      const flkty = Flickity.data(container);

      products.forEach((product) => {
        product.classList.remove('carousel__slide');
        container.append(product);
      });

      activeProducts.forEach((product) => {
        product.classList.add('carousel__slide');
      });

      if (flkty) {
        flkty.insert(activeProducts);
        flkty.reloadCells();
        flkty.select(0, 0, 1);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}